<div class="next-nav" #navigation>
  <nav class="next-nav__main" id="main-navigation" data-test-id="new-nav-main-part">
    <top-section-nav class="next-nav__main__top-section-nav" [activeScreen]="activeScreen" [screens]="screens"></top-section-nav>
    <bottom-section-nav [settingsScreen]="settingsScreen" [activeScreen]="activeScreen"></bottom-section-nav>
  </nav>
  <sub-navigation class="next-nav__sub" *ngIf="activeScreen" [activeScreen]="activeScreen"></sub-navigation>
</div>
